import React from 'react';
import { ChevronDownSVG } from '../../@common_components/svgs/chevron-down.svg';

const ChevronDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <ChevronDownSVG {...props} />;
};

export { ChevronDownIcon };
